module.exports = __webpack_public_path__ + "img/full-microbac-2.5707c4cb.jpg";